import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes.jsx";
import Navbar from "./shared/navbar/Navbar.jsx";
import Sidebar from "./shared/Sidebar.jsx";
import UserProfile from "./shared/UserProfile.js";
import Footer from "./shared/Footer.jsx";
const App = () => {

  const [isFullPageLayout, setIsFullPageLayout] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const includes = (string) => location.pathname.includes(string);


  const getCategoryName = () => {

    if (includes("/inspectores")) return "TMI | Verificadores";

    if (includes("/inspecciones")) return "TMI | Inspecciones";

    return "TMI";
  };

  const getPageName = () => {
    const path = location.pathname;

    // Home con o sin prefijo
    if (path === "/" || path === "/controlsube" || path === "/controlsube/") {
      return " | Inicio";
    }

    if (includes("inspectores") || includes("inspecciones")) return "";

    // Divido en partes e ignoro vacíos
    const parts = path.split("/").filter(Boolean);

    if (parts.length === 0) return " | Inicio";

    // Detecto si el primer segmento es un prefijo (ej: controlsube)
    const isPrefixed = parts[0].toLowerCase() === "controlsube";

    // Obtengo la ruta real (la primera después del prefijo si existe)
    const route = isPrefixed ? parts[1] : parts[0];

    if (!route) return "";

    // Reemplazo guiones y capitalizo
    const name = route.replace(/-/g, " ");
    const finalName = name.charAt(0).toUpperCase() + name.slice(1);

    return ` | ${finalName}`;
  };

  const getActionName = () => {
    if (includes("informacion")) return " | Información detallada";

    if (includes("crear")) return " | Creando ";

    if (includes("modificar")) return " | Modificando";

    return "";
  };

  const generateTitle = () => {
    return getCategoryName() + getPageName() + getActionName();
  };

  const onRouteChanged = () => {
    window.scrollTo(0, 0);
    const fullPageLayoutRoutes = [
      "/login",
      "/forgot-password",
      "/user-pages/login-1",
      "/user-pages/login-2",
      "/user-pages/register-1",
      "/user-pages/register-2",
      "/user-pages/lockscreen",
      "/error-pages/error-404",
      "/error-pages/error-500",
      "/general-pages/landing-page",
    ];
    const pageBodyWrapper = document.querySelector(".page-body-wrapper");
    for (let i = 0; i < fullPageLayoutRoutes.length; i++) {
      if (location.pathname === fullPageLayoutRoutes[i]) {
        setIsFullPageLayout(true);
        pageBodyWrapper?.classList.add("full-page-wrapper");
        break;
      } else {
        setIsFullPageLayout(false);
        pageBodyWrapper?.classList.remove("full-page-wrapper");
      }
    }
  };

  const handleKeyDown = (event) => {
    // Check if backspace was pressed and the target is not an input element
    if (
      event.key === "Backspace" &&
      !["INPUT", "TEXTAREA", "SELECT"].includes(event.target.tagName) &&
      !event.target.isContentEditable
    ) {
      event.preventDefault();
      navigate(-1);
    }
  };

  useEffect(() => {
    setMobileOpen(false);
    onRouteChanged();
    document.title = generateTitle();
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [location]);

  const isAuthenticated = !!UserProfile.getInstance().getToken();

  if (!isAuthenticated) {
    return <AppRoutes />;
  }

  let navbarComponent = !isFullPageLayout
    ? <Navbar onToggleMobile={() => setMobileOpen(o => !o)} mobileOpen={mobileOpen} />
    : "";
  let sidebarComponent = !isFullPageLayout
    ? <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
    : "";
  let overlayComponent = !isFullPageLayout && mobileOpen
    ? <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />
    : null;
  let footerComponent = !isFullPageLayout ? <Footer /> : null;

  return (
    <div className="container-scroller">
      {navbarComponent}
      {overlayComponent}
      <div className="container-fluid page-body-wrapper">
        {sidebarComponent}
        <div
          className="main-panel"

        >
          <div
            className={
              location.pathname === "/"
                ? "content-wrapper-home"
                : "content-wrapper"
            }
          >
            <AppRoutes />
          </div>
          {footerComponent}
        </div>
      </div>
    </div>
  );
};

export default App;
